/*
 *
 */

import * as React from 'react';
import { connect } from 'react-redux';

import {
    toggleEditDocumentTypeModal,
    updateDocumentType,
    deleteDocumentType,
    setSelectedDocumentTypeID,
    clearSelectedDocumentTypeID
} from '../../../actions/manageDocumentTypeActions';
import { EditDocumentTypeForm } from '../forms/EditDocumentTypeForm';
import { withTranslation, WithTranslation } from 'react-i18next';
import CommonModal, { IPropsCommonModal } from '../../common/CommonModal';
import CommonMobileModal from '../../common/mobile/CommonMobileModal';
import { selectIsLoading } from '../../../reducers/commonReducers';
import { getIsMobile } from '../../../reducers/configReducer';
import { IinitialState } from '../../../reducers';

interface Iprops {
    colorButton: string;
}

/*
 * Desktop keeps the slide-in flyout; mobile gets the same full-screen card
 * as the Edit Document modal (which it opens on top of - see the
 * edit-document-type-mobile-modal z-index in ManageDocumentLibrary.less)
 */
const ResponsiveDocumentTypeModal: React.FC<IPropsCommonModal & {
    isMobile: boolean;
}> = props =>
    props.isMobile ? (
        <CommonMobileModal {...props}>
            <EditDocumentTypeForm {...(props as any)} />
        </CommonMobileModal>
    ) : (
        <CommonModal {...props}>
            <EditDocumentTypeForm {...(props as any)} />
        </CommonModal>
    );

const mapStateToProps = (
    state: IinitialState,
    ownProps: Iprops & WithTranslation
) => {
    const selectedDocumentType =
        state.manageDocumentType.documentTypesByID[
            state.manageDocumentType.selectedDocumentTypeID
        ];
    const title = ownProps.t('manageDocument:editDocumentType');
    const isMobile = getIsMobile(state);

    return {
        user: state.user,
        loading: selectIsLoading(state),
        show: state.manageDocumentType.showEditDocumentTypeModal,
        selectedDocumentType,
        isMobile,
        className: isMobile
            ? 'edit-tab edit-document-type-mobile-modal'
            : 'edit-tab second-modal',
        title
    };
};

export const EditDocumentTypeModal = withTranslation('manageDocument')(
    connect(mapStateToProps, {
        toggleEditDocumentTypeModal,
        onToggle: toggleEditDocumentTypeModal,
        onHide: toggleEditDocumentTypeModal,
        onCancel: toggleEditDocumentTypeModal,
        updateDocumentType,
        deleteDocumentType,
        setSelectedDocumentTypeID,
        clearSelectedDocumentTypeID
    })(ResponsiveDocumentTypeModal)
);
